import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth, db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';
import { motion } from 'framer-motion';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import { CardContent } from '../components/ui/cardContent';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const result = await signInWithEmailAndPassword(auth, email, password);
      const tokenResult = await result.user.getIdTokenResult();

      if (tokenResult.claims.admin) {
        navigate('/admin');
      } else {
        const userRef = doc(db, 'users', result.user.uid);
        const snap = await getDoc(userRef);

        if (snap.exists()) {
          const data = snap.data();
          if (!data.isActive) {
            navigate('/home');
          } else if (data.accessType === 'pro') {
            navigate('/home');
          } else {
            navigate('/home');
          }
        } else {
          navigate('/contact');
        }
      }
    } catch (error) {
      alert('Invalid credentials. Try again!');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-yellow-100 via-pink-100 to-purple-200 px-4">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="w-full max-w-md"
      >
        <Card className="bg-white/80 backdrop-blur-md shadow-xl rounded-3xl border border-purple-200">
          <CardContent className="p-8">
          <div className="flex justify-center mb-4">
              <img src="/assets/BrainyBuddy.png" alt="Brainy Buddy Logo" className="h-20 w-20" />
            </div>
            <h1 className="text-3xl font-bold text-purple-700 mb-1 text-center"> Brainy Buddy </h1>
            <p className="text-center text-sm text-gray-600 mb-6">Power Up Yourself with Brain Games</p>
            <form onSubmit={handleLogin} className="space-y-4">
              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full p-3 border border-purple-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-400"
              />
              <input
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="w-full p-3 border border-purple-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-400"
              />
              <Button className="w-full bg-purple-600 hover:bg-purple-700 rounded-xl py-3 transition">Login</Button>
            </form>
            <p className="text-sm text-center text-gray-600 mt-4">
              Don’t have an account?{' '}
              <a href="/register" className="text-purple-700 underline font-semibold">Register</a>
            </p>
          </CardContent>
        </Card>
      </motion.div>
    </div>
  );
};

export default Login;
